import { render, staticRenderFns } from "./payment_item.vue?vue&type=template&id=89d906ce&scoped=true&"
import script from "./payment_item.vue?vue&type=script&lang=js&"
export * from "./payment_item.vue?vue&type=script&lang=js&"
import style0 from "./payment_item.vue?vue&type=style&index=0&id=89d906ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d906ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89d906ce')) {
      api.createRecord('89d906ce', component.options)
    } else {
      api.reload('89d906ce', component.options)
    }
    module.hot.accept("./payment_item.vue?vue&type=template&id=89d906ce&scoped=true&", function () {
      api.rerender('89d906ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/payments/item/payment_item.vue"
export default component.exports